import React from 'react';
import { KeyboardDatePicker  } from 'mui-rff';

export default function DateTimePickerAdapter(props) {

  return (<KeyboardDatePicker
    disableToolbar
    variant='inline'
    ampm={false}
    format="dd.MM.yyyy"
    {...props}
  />)

}